import { useEffect, useState } from 'react';
import { getScopeRole } from '../dataTransformation/role';
import { ETypeUser } from '../store/model/store.model';

const constrolAccessUserlight = (): Promise<boolean> => {
    return new Promise((resolve) => {
        if (window.localStorage.getItem('scope')) {
            const islight = [JSON.parse(window.localStorage.getItem('scope')!)].includes(ETypeUser.LIGHT);
            resolve(islight);
        } else {
            getScopeRole()
                .then((response) => {
                    const islight = response === ETypeUser.LIGHT;
                    window.localStorage.setItem('scope', JSON.stringify(response));
                    resolve(islight);
                })
                .catch((error) => {
                    console.error(error);
                    resolve(false);
                });
        }
    });
};

const useUserlight = () => {
    const [light, setLight] = useState<boolean>(
        [JSON.parse(window.localStorage.getItem('scope')!)].includes(ETypeUser.LIGHT),
    );
    const handleScopeUser = async () => {
        const scope = await constrolAccessUserlight();

        if (scope) setLight(scope);
    };
    useEffect(() => {
        if (!window.localStorage.getItem('scope')) {
            handleScopeUser();
        }
    }, []);
    return light;
};

export default useUserlight;
